import colorSystem from 'src/scss/_colors-system.module.scss';

export const TREEMAP_PALLET_COLOR = [
  colorSystem.blue100,
  colorSystem.cyan100,
  colorSystem.green100,
  colorSystem.orange100,
  colorSystem.rose100,
  colorSystem.lime100,
  colorSystem.purple100,
  colorSystem.lightBlue100,
  colorSystem.yellow100,
  colorSystem.indigo100,
  colorSystem.neutroState100,
];

export const TREEMAP_PALLET_COLOR_HS_CODE = [
  colorSystem.blue900,
  colorSystem.cyan900,
  colorSystem.green900,
  colorSystem.orange900,
  colorSystem.rose900,
  colorSystem.lime900,
  colorSystem.deepPurple900,
  colorSystem.lightBlue900,
  colorSystem.yellow900,
  colorSystem.indigo900,
  colorSystem.neutroState900,
];


export const generateTreemapColors = (baseColor: string, numColors = 10) => {
  const s = new Option().style;
  s.color = baseColor;
  if (!s.color) return [];
  const colors: string[] = [];
  const opacityStart = 0.2;
  for (let i = 0; i < numColors; i++) {
    const opacity = opacityStart + i * 0.1;
    const rgbValues = s.color.replace('rgb(', '').replace(')', '').split(',');
    const [red, green, blue] = rgbValues;
    colors.push(`rgba(${red}, ${green}, ${blue}, ${opacity.toFixed(2)})`);
  }
  return colors;
};
